import fp from 'lodash/fp';
import React, { useEffect } from 'react';
import { isBefore } from 'date-fns';
import { Badge, Button } from 'react-bootstrap';
import Spinner from 'react-spinkit';
import { connect } from "react-redux";
import { LinkContainer } from 'react-router-bootstrap';
import { compose, withHandlers } from "recompose";
import { bindActionCreators } from 'redux';
import { pluralise } from '../../../../..//utils';
import { routes, searchTileType } from '../../../../../constants';
import { taskActions } from '../../../../../state/modules/task';
import { currentUserSelector } from '../../../../../state/modules/user';
import { Icon } from '../../../../components';

const step1 = ({ stepForward, stepBack, currentStep }) => (<div id='set-task-footer'>
  <LinkContainer to={routes.app.tasks.home}>
    <Button bsStyle='plain'>Cancel</Button>
  </LinkContainer>
</div>)

const step2 = ({
  stepForward,
  stepBack,
  stepTo,
  task,
  taskEditing,
  reviewing,
  onShowModal,
  expireBeforeDueDateContents,
  setExpireBeforeDueDateContents,
}) => {
  const totalSelected = task.searchTiles.value.length + task.businessLibraryContent.value.length;

  const isEmptyContent = (task.searchTiles.value.length + task.businessLibraryContent.value.length) === 0;

  useEffect(() => {
    const newExpireBeforeDueDateContents = fp.flow(
      fp.concat(task.businessLibraryContent.value),
      fp.filter(({ expiryDate }) => isBefore(new Date(expiryDate), (new Date(task.dueDate.value)))),
    )(task.searchTiles.value);

    setExpireBeforeDueDateContents(newExpireBeforeDueDateContents);
  }, [task.searchTiles.value]);

  
  const onNextButtonClick = (nextFunc) => () => {
    if (expireBeforeDueDateContents.length > 0) {
      onShowModal();
    } else {
      nextFunc();
    }
  }

  return (<div id='set-content-footer'>
    <Button className='left' onClick={stepBack} bsStyle='plain'>Back</Button>
    <Badge className='content-count'>
      {`${totalSelected} ${pluralise('item', totalSelected)} selected`}
    </Badge>
    {
      (taskEditing || reviewing) ?
        <Button className='right' onClick={onNextButtonClick(() => stepTo(3))} disabled={isEmptyContent}>
          Review<Icon className='left-gap' icon='chevron-right-large' />
        </Button> :
        <Button className='right' onClick={onNextButtonClick(stepForward)} disabled={isEmptyContent}>
          Add Members<Icon className='left-gap' icon='chevron-right-large' />
        </Button>
    }
    <LinkContainer to={routes.app.tasks.home}>
      <Button className='right' bsStyle='plain'>Cancel</Button>
    </LinkContainer>
  </div>)
}

const step3 = ({ stepForward, stepBack, currentStep, task }) => (<div id='set-user-footer'>
  <Button className='left' onClick={stepBack} bsStyle='plain'>Back</Button>
  <Badge className='user-count'>{`${task.teams.value.length > 0 ? `${task.teams.value.length} ${pluralise('team', task.teams.value.length)} +` : ''} ${task.users.value.length} ${pluralise('individual', task.users.value.length)} selected`}</Badge>
  <Button className='right' onClick={stepForward} disabled={task.users.value.length === 0}>Review<Icon className='left-gap' icon='chevron-right-large' /></Button>
  <LinkContainer to={routes.app.tasks.home}>
    <Button className='right' bsStyle='plain'>Cancel</Button>
  </LinkContainer>
</div>)

const step4 = compose(
  connect(
    (state) => ({
      user: currentUserSelector(state),
      isAssigningTask: state.task.isAssigningTask
    }),
    (dispatch) => ({
      assignTask: bindActionCreators(taskActions.task.assignTask, dispatch),
      updateTask: bindActionCreators(taskActions.task.updateTask, dispatch)
    })
  ),
  withHandlers({
    assignTask: ({ assignTask, user, task }) => () => {
      const taskToCreate = {
        name: task.name.value,
        description: task.description.value,
        dueDate: task.dueDate.value,
        isArchived: task.isArchived.value,
        contents: fp.flow(
          fp.filter(({ type }) => type === searchTileType.Content),
          fp.map(({ id }) => id),
          fp.concat(
            fp.map('id')(task.businessLibraryContent.value)
          ),
          fp.uniq
        )(task.searchTiles.value),
        courses: fp.flow(
          fp.filter(({ type }) => type === searchTileType.Course),
          fp.map(({ id }) => id)
        )(task.searchTiles.value),
        users: task.users.value,
        links: [],
        cpdCategorys: [],
        files: []
      }
      assignTask(taskToCreate, user)
    },
    updateTask: ({ updateTask, user, task, taskEditing }) => () => {
      const taskToUpdate = {
        id: fp.get('id')(taskEditing),
        name: task.name.value,
        description: task.description.value,
        dueDate: task.dueDate.value,
        isArchived: task.isArchived.value,
        contents: fp.flow(
          fp.filter(({ type }) => type === searchTileType.Content),
          fp.map(({ id }) => id),
          fp.concat(
            fp.map('id')(task.businessLibraryContent.value)
          ),
          fp.uniq
        )(task.searchTiles.value),
        courses: fp.flow(
          fp.filter(({ type }) => type === searchTileType.Course),
          fp.map(({ id }) => id)
        )(task.searchTiles.value),
        users: task.users.value,
        links: [],
        cpdCategorys: [],
        files: [],
        existingFiles: []
      }
      updateTask(taskToUpdate, user)
    }
  })
)(({ stepBack, assignTask, updateTask, taskEditing, isAssigningTask }) => (<div id='review-footer'>
  <Button className='left' bsStyle='plain' onClick={stepBack}>Back</Button>
  {
    taskEditing ?
      <Button className='right' onClick={updateTask}>Update task</Button> :
      <Button className='right' onClick={assignTask} disabled={isAssigningTask}>
        {
          isAssigningTask
            ? <Spinner name='circle' className='spinner' fadeIn='none' />
            : "Assign task"
        }
      </Button>
  }
  <LinkContainer to={routes.app.tasks.home}>
    <Button bsStyle='plain'>Cancel</Button>
  </LinkContainer>
</div>))

export const footers = {
  step1,
  step2,
  step3,
  step4
}


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/partials/set-task-content-footer.js